export default "__VITE_ASSET__DXSQ2aJO__"